
<style>
  .Special{
    background-color:#ff9595 !important;
  }

</style>

<div class="col-md-12 mb-30"  [hidden]="Data_View_Customer.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات  مشتریان </h5>
     <br/>
     <br>
      <div class="row">
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-success rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-vcard highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark">	تعداد مشتریان </p>
                  <h4>{{total}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-info rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-vcard highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> 	تعداد تعاریف <b>ماه جاری</b></p>
                  <h4>{{current_Month_create}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-statistics h-100">
            <div class="card-body">
              <div class="clearfix">
                <div class="float-left icon-box bg-warning rounded-circle">
                  <span class="text-white">
                    <i class="fa fa-vcard highlight-icon" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="float-right text-right">
                  <p class="card-text text-dark"> تعداد ویرایش  <b>ماه جاری</b> </p>
                  <h4>{{current_Month_update}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>
     <br/>
     <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">بازه زمانی</label>
        <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
          <option value="0">اعمال نشود</option>
          <option value="1">اعمال شود (تاریخ مشتری)</option>
          <option value="2">اعمال شود (تاریخ انجام نامه)</option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">تاریخ شروع</label>
        <input type="text" (keyup.enter)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)" #datepickerInputStart placeholder="اینجا تایپ کنید ..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">تاریخ پایان</label>
        <input type="text" (keyup.enter)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)" #datepickerInputEnd  placeholder="اینجا تایپ کنید ..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">زمینه فعالیت</label>
        <select class="custom-select" [(ngModel)]="FeildActivityId">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_FeildActivity" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
    </div>
     <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">نام مشتری </label>
        <input [(ngModel)]="Name" (keyup.enter)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)" type="text" class="form-control"  placeholder="برای جستجوی اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">کد مشتری </label>
        <input [(ngModel)]="Code" (keyup.enter)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)" type="text" class="form-control"  placeholder="برای جستجوی اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">استان </label>
        <select class="custom-select" [(ngModel)]="ProvinceId"  (change)="ProvinceChange()">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">شهرستان</label>
        <select class="custom-select" [(ngModel)]="CityId" >
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">نام کارشناس</label>
        <input [(ngModel)]="Karshenas" (keyup.enter)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)" type="text" class="form-control"  placeholder="برای جستجوی اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">آدرس گواهی نامه</label>
        <select class="custom-select" [(ngModel)]="HasCertificateAddress" name="HasCertificateAddress">
          <option value="0">همه موارد</option>
          <option value="1">بدون آدرس گواهی نامه</option>
        </select>
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-12" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button *ngIf="!Procssing" routerLink="/CustomerAdd" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
        <button *ngIf="!Procssing" (click)="exportexcel()" type="button"  class="btn btn-warning" style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <button *ngIf="Procssing" type="button" class="btn btn-info" style="margin-left: 5px;"> لطفا صبر نمائید ... <i
          class="fa fa-spin fa-spinner"></i> </button>
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام مشتری</th>
              <th>نام کاربری</th>
              <th>کد مشتری</th>
              <th>شناسه ملی</th>
              <th>وضیعت</th>
              <th>ایجاد کننده</th>
              <th>تاریخ ایجاد</th>
              <th>ویرایش کننده</th>
              <th>تاریخ ویرایش</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }
            " [ngClass]="{'Special': item.special}">
             <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td *ngIf="item.username">{{item.username}}</td>
              <td *ngIf="!item.username">
                <a class="btn btn-danger" [routerLink]="['/Cutomeruserform',{id:item.id}]"> ثبت کاربری </a>
              </td>
              <td>{{item.code}}</td>
              <td>{{item.shenasehMeli}}</td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">فعال</p>
                <p *ngIf="item.del" style="color: crimson;">غیر فعال</p>
              </td>
              <td>{{item.create_user}} </td>
              <td>{{item.create_date}} </td>
              <td>{{item.update_user}} </td>
              <td>{{item.update_date}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a class="dropdown-item" [routerLink]="['/CustomerEdit',{id:item.id}]"><i class="fa fa-edit"></i> ویرایش </a>
                          <a class="dropdown-item" [routerLink]="['/Cutomeruserform',{id:item.id}]"><i class="fa fa-user"></i> کاربری </a>

                          <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Customer_view(item,'Title')"><i class="fa fa-archive"></i> آرشیو نام ها </a>
                          <!--
                            <a target="_blank"  href="{{BaseUrl}}{{item.id}}" class="dropdown-item" ><i class="fa fa-file-pdf-o"></i> Pdf </a>
                          -->
                          <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-lock"></i> غیرفعال </a>
                          <a *ngIf="item.del==true" style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-unlock"></i> فعال </a>

                          <a *ngIf="item.special==false" style="cursor: pointer;" class="dropdown-item" (click)="openModalSpecial(templateSpecial,item)"><i class="fa fa-bookmark"></i> خاص </a>
                          <a *ngIf="item.special==true" style="cursor: pointer;" class="dropdown-item" (click)="openModalSpecial(templateSpecial,item)"><i class="fa fa-bookmark-o"></i> عدم خاص </a>

                          <a  style="cursor: pointer;" class="dropdown-item" (click)="openModalAcrchive(templateAcrchive,item)"><i class="fa fa-remove"></i> حذف</a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Customer"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<app-CutomerTitle
  *ngIf="Data_View_Customer.id>0 && Data_View_Customer_Switcher=='Title'"
  (OnBack_Title_Action)="OnBack_Componet_Action_Rest($event)"
  [Customer_Inner]="Data_View_Customer">

</app-CutomerTitle>



<table id="excel-table" style="display: none;" >
  <thead >
    <tr>
      <th>#</th>
      <th>نام مشتری</th>
      <th>کد مشتری</th>
      <th>شناسه ملی</th>
      <th>وضیعت</th>
      <th>نام کارشناس</th>
      <th>سمت</th>
      <th>توضیحات</th>
      <th>شمراه تلفن همراه</th>
      <th> تلفن همراه جایگزین </th>
      <th>تلفن همراه فضای مجازی</th>

      <th>ایمیل1</th>
      <th>داخلی1</th>
      <th>تلفن1</th>

      <th>ایمیل2</th>
      <th>داخلی2</th>
      <th>تلفن2</th>

      <th>ایمیل3</th>
      <th>داخلی3</th>
      <th>تلفن3</th>


      <th>عنوان آدرس1</th>
      <th>آدرس1</th>
      <th>آدرس گواهی نامه 1</th>
      <th>کدپستی1</th>
      <th>پیش شماره1</th>
      <th>تلفن1</th>
      <th>داخلی1</th>
      <th>فاکس1</th>

      <th>عنوان آدرس2</th>
      <th>آدرس2</th>
      <th>آدرس گواهی نامه 2</th>
      <th>کدپستی2</th>
      <th>پیش شماره2</th>
      <th>تلفن2</th>
      <th>داخلی2</th>
      <th>فاکس2</th>

      <th>عنوان آدرس3</th>
      <th>آدرس3</th>
      <th>آدرس گواهی نامه 3</th>
      <th>کدپستی3</th>
      <th>پیش شماره3</th>
      <th>تلفن3</th>
      <th>داخلی3</th>
      <th>فاکس3</th>

      <th>تاریخ ایجاد</th>
      <th>ایجاد کننده</th>
      <th>تاریخ ویرایش</th>
      <th>ویرایش کننده</th>

    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Customer_Excel">
     <td>{{DataList_Customer_Excel.indexOf(item)+1}}</td>
     <td>{{item.name}}</td>
     <td>{{item.code}}</td>
     <td>{{item.shenasehMeli}}</td>
     <td>{{item.status}}</td>
     <td>{{item.name_karshnas}}</td>
     <td>{{item.semat}}</td>
     <td>{{item.dsc}}</td>
     <td>{{item.moble1}}</td>
     <td>{{item.jaygozinMiblie1}}</td>
     <td>{{item.majaziMobile1}}</td>

     <td>{{item.email1}}</td>
     <td>{{item.dakheli1}}</td>
     <td>{{item.tel1}}</td>


     <td>{{item.email2}}</td>
     <td>{{item.dakheli2}}</td>
     <td>{{item.tel2}}</td>

     <td>{{item.email3}}</td>
     <td>{{item.dakheli3}}</td>
     <td>{{item.tel3}}</td>


     <td>{{item.title1}}</td>
     <td>{{item.address1}}</td>
     <td>{{item.addressCer1}}</td>
     <td>{{item.codepost1}}</td>
     <td>{{item.pishShomareh1}}</td>
     <td>{{item.address_Tel1}}</td>
     <td>{{item.address_Dakheli1}}</td>
     <td>{{item.fax1}}</td>


     <td>{{item.title2}}</td>
     <td>{{item.address2}}</td>
     <td>{{item.addressCer2}}</td>
     <td>{{item.codepost2}}</td>
     <td>{{item.pishShomareh2}}</td>
     <td>{{item.address_Tel2}}</td>
     <td>{{item.address_Dakheli2}}</td>
     <td>{{item.fax2}}</td>


     <td>{{item.title3}}</td>
     <td>{{item.address3}}</td>
     <td>{{item.addressCer3}}</td>
     <td>{{item.codepost3}}</td>
     <td>{{item.pishShomareh3}}</td>
     <td>{{item.address_Tel3}}</td>
     <td>{{item.address_Dakheli3}}</td>
     <td>{{item.fax3}}</td>

     <td>{{item.createrDate}}</td>
     <td>{{item.createrUser}}</td>
     <td>{{item.updateDate}}</td>
     <td>{{item.updateUser}}</td>

    </tr>
  </tbody>
</table>




<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.del==false" class="modal-title pull-left">تایید غیرفعال اطلاعات  مشتری '{{Data_Seleted_Delete.name}}' </h4>
     <h4 *ngIf="Data_Seleted_Delete.del==true" class="modal-title pull-left">تایید فعال اطلاعات  مشتری '{{Data_Seleted_Delete.name}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.del==false" type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> غیرفعال کردن اطلاعات <i class="fa fa-lock"></i></button>
    <button *ngIf="Data_Seleted_Delete.del==true"  type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> فعال کردن اطلاعات <i class="fa fa-unlock"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateSpecial>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.special==false" class="modal-title pull-left">تایید خاص بودن  مشتری '{{Data_Seleted_Delete.name}}' </h4>
     <h4 *ngIf="Data_Seleted_Delete.special==true" class="modal-title pull-left">تایید عدم خاص بودن  مشتری '{{Data_Seleted_Delete.name}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Special.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.special==false" type="button" class="btn btn-warning" (click)="Special(Data_Seleted_Delete)"> تایید خاص بودن اطلاعات <i class="fa fa-bookmark"></i></button>
    <button *ngIf="Data_Seleted_Delete.special==true"  type="button" class="btn btn-warning" (click)="Special(Data_Seleted_Delete)"> تایید عدم خاص بودن اطلاعات <i class="fa fa-bookmark-خ"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Special.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateAcrchive>
  <div class="modal-header">
    <h4 class="modal-title pull-left">تایید حذف اطلاعات  مشتری '{{Data_Seleted_Delete.name}}' </h4>

     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Acrchive.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button  type="button" class="btn btn-warning" (click)="Acrchive(Data_Seleted_Delete)"> حذف کردن اطلاعات <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Acrchive.hide()">بستن</button>
  </div>
</ng-template>

